const translations = {
  en: {
    // Navbar
    nav: {
      home: 'Home',
      useCases: 'Use Cases',
      pricing: 'Pricing',
      about: 'About',
      contact: 'Contact',
      Features: 'Features',
      getStarted: 'Get Started',
    },

    // Footer
    footer: {
      tagline: 'AI-powered identity verification and fraud detection for the modern enterprise.',
      product: 'Product',
      company: 'Company',
      legal: 'Legal',
      features: 'Features',
      Features: 'Features',
      pricing: 'Pricing',
      api: 'API Docs',
      about: 'About Us',
      careers: 'Careers',
      blog: 'Blog',
      press: 'Press',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      gdpr: 'GDPR',
      compliance: 'Compliance',
      rights: 'All rights reserved.',
      built: 'Built with AI. Secured by design.',
    },

    // Home
    home: {
      badgeText: 'Trusted by 5+ enterprises worldwide',
      heroTitle1: 'Identity Verification',
      heroTitle2: 'Powered by',
      heroTitle3: 'AI Precision',
      heroSubtitle: 'KYCPro.AI delivers enterprise-grade KYC & AML compliance with real-time verification, fraud detection, and seamless integration — all in under 2 seconds.',
      startTrial: 'Start Free Trial',
      exploreUseCases: 'Explore Use Cases',
      Features: 'Features',
      verificationActive: 'Verification Active',
      idVerified: '✓ ID Verified',
      livenessPass: '✓ Liveness Pass',
      amlClear: '✓ AML Clear',
      stats: [
        { value: '99.8%', label: 'Accuracy Rate' },
        { value: '<2s', label: 'Verification Speed' },
        { value: '190+', label: 'Countries Covered' },
        { value: '10M+', label: 'Verifications Done' },
      ],
      trustedLabel: 'Trusted by leading financial institutions',
      capabilitiesTag: 'Capabilities',
      capabilitiesTitle1: 'Everything You Need for',
      capabilitiesTitle2: 'Modern KYC Compliance',
      capabilitiesDesc: 'A complete identity verification platform built for speed, accuracy, and global scale.',
      features: [
        { title: 'Real-Time ID Verification', desc: 'Instantly verify government-issued IDs, passports, and driver\'s licenses using advanced AI document analysis.' },
        { title: 'Liveness Detection', desc: 'Prevent spoofing attacks with our 3D liveness detection that distinguishes real users from photos or deepfakes.' },
        { title: 'Global Coverage', desc: 'Support for 10,000+ document types across 190+ countries with multi-language OCR and data extraction.' },
        { title: 'Instant Decisions', desc: 'Sub-2-second verification decisions powered by parallel AI models running on edge infrastructure.' },
        { title: 'Risk Scoring', desc: 'Dynamic risk scoring with explainable AI signals to help your compliance team make informed decisions.' },
        { title: 'AML & PEP Screening', desc: 'Screen users against global sanction lists, PEP databases, and adverse media in real time.' },
      ],
      securityTag: 'Security & Compliance',
      securityTitle1: 'Built for the Most',
      securityTitle2: 'Regulated Industries',
      securityDesc: 'Our platform meets the strictest regulatory requirements across financial services, healthcare, and fintech — so you can focus on growth, not compliance overhead.',
      benefits: [
        'GDPR & CCPA compliant by design',
        'No data stored without consent',
        'End-to-end encrypted pipeline',
        'Dedicated compliance support',
      ],
      talkCompliance: 'Talk to Compliance Team',
      ctaTitle: 'Ready to Verify Smarter?',
      ctaDesc: 'Be among the top five organizers to use KYCPro.AI to verify identities in seconds, reduce fraud, comply with laws and get unique features.',
      viewUseCases: 'View Use Cases',
    },

    // Use Cases
    useCases: {
      tag: 'Use Cases',
      title1: 'Verification for',
      title2: 'Every Industry',
      desc: 'From fintech to healthcare, KYCPro.AI powers compliant identity verification across the world\'s most regulated industries.',
      getStarted: 'Get Started',
      ctaTitle: "Don't See Your Industry?",
      ctaDesc: 'Our platform is flexible and can be customized for any regulated industry. Talk to our team to build a custom verification flow.',
      contactSales: 'Contact Sales',
      cases: [
        {
          category: 'Financial Services',
          title: 'Onboard Customers with Zero Friction',
          desc: 'Banks and fintechs use KYCPro.AI to verify new customers in seconds — reducing drop-off rates by up to 70% while staying fully compliant with AML and KYC regulations.',
          benefits: ['Automated document verification', 'PEP & sanctions screening', 'Risk-based onboarding flows', 'Full audit trail'],
        },
       /*  {
          category: 'E-Commerce & Marketplaces',
          title: 'Eliminate Fraudulent Sellers & Buyers',
          desc: 'Marketplaces use our platform to verify merchant identities, prevent account takeover, and build trust between buyers and sellers at massive scale.',
          benefits: ['Seller identity verification', 'Chargeback fraud prevention', 'Account takeover protection', 'Buyer trust signals'],
        },
        {
          category: 'Healthcare',
          title: 'Verify Patient Identity Securely',
          desc: 'Healthcare platforms use KYCPro.AI to onboard patients, verify practitioner credentials, and ensure HIPAA-compliant identity verification across telehealth workflows.',
          benefits: ['HIPAA compliant flows', 'Practitioner credential checks', 'Insurance verification', 'Zero PHI stored'],
        },
        {
          category: 'Gaming & iGaming',
          title: 'Age Verification & Player Protection',
          desc: 'Gaming operators use our platform for real-time age verification, responsible gambling compliance, and fraud prevention across jurisdictions.',
          benefits: ['Real-time age verification', 'Geo-compliance checks', 'Problem gambling signals', 'Fraud pattern detection'],
        }, */
        {
          category: 'Real Estate',
          title: 'KYC for Property Transactions',
          desc: 'Real estate platforms and agencies verify buyers, sellers, and agents digitally — eliminating paper-based KYC and ensuring anti-money laundering compliance.',
          benefits: ['Digital document signing', 'UBO verification', 'AML screening', 'Transaction monitoring'],
        },
        {
          category: 'Travel & Hospitality',
          title: 'Frictionless Guest Verification',
          desc: 'Travel companies and hotels use KYCPro.AI to pre-verify guests digitally — reducing check-in time, preventing chargebacks, and securing bookings.',
          benefits: ['Passport scanning & NFC', 'Booking fraud prevention', 'Digital check-in flows', 'International ID support'],
        },
      ],
    },

    // About
    about: {
      tag: 'About Us',
      title1: "We're on a Mission to Make",
      title2: 'Identity Verification Trustless',
      desc: "KYCPro.AI was founded to eliminate the friction, inaccuracy, and privacy risks of traditional KYC processes — replacing them with AI-driven precision.",
      storyTag: 'Our Story',
      storyTitle1: 'From Frustration',
      storyTitle2: 'to Innovation',
      storyP1: "Our founders spent years building compliance infrastructure at major banks in The Middle East — and were tired of watching customers abandon onboarding flows because of slow, unreliable identity checks.",
      storyP2: "In 2025, they left to build the platform they always wished existed: one that could verify anyone, anywhere, in seconds — without sacrificing security or compliance.",
      storyP3: "Today, KYCPro.AI processes millions of verifications each month for some of the world's most regulated businesses. We're just getting started.",
      milestones: [
        { year: '2025', event: 'Founded in The Middle East with a mission to make identity verification frictionless' },
        { year: '2025', event: 'Launched v1 with 5 enterprise customers across 3 countries' },
        { year: '2026', event: 'Reached 10M verifications; achieved SOC 2 Type II & ISO 27001 certifications' },
        { year: '2026', event: 'Launched next-gen AI models with 99.8% accuracy across 10,000+ document types' },
      ],
      valuesTag: 'Our Values',
      valuesTitle1: 'What Drives',
      valuesTitle2: 'Everything We Do',
      values: [
        { title: 'Precision First', desc: 'Every decision we make is grounded in accuracy. We obsess over false positives and false negatives because compliance errors have real consequences.' },
        { title: 'Privacy by Design', desc: "We never store data we don't need. Privacy is not a checkbox for us — it's built into every component of our platform architecture." },
        { title: 'Speed Matters', desc: 'Slow verification costs you conversions. We built our infrastructure to deliver decisions in under 2 seconds, globally, without sacrificing accuracy.' },
        { title: 'Customer Obsession', desc: "We embed with our customers' compliance teams, understand their specific regulatory environments, and build solutions that fit their reality." },
      ],
      teamTag: 'Leadership',
      teamTitle1: 'The Team Behind',
      teamTitle2: 'KYCPro.AI',
      team: [
        { name: '', role: 'CEO & Co-Founder' },
        { name: '', role: 'CTO & Co-Founder' },
        { name: '', role: 'Chief Compliance Officer' },
      ],
      ctaTitle: 'Join Us on the Mission',
      ctaDesc: "Whether you're a customer, partner, or future teammate — we'd love to connect.",
      getInTouch: 'Get in Touch',
      openRoles: 'View Open Roles',
    },

    // Contact
    contact: {
      tag: 'Contact',
      title1: "Let's Talk",
      title2: 'Verification',
      desc: "Whether you need a demo, have compliance questions, or are ready to integrate — our team is here.",
      infoTitle: 'Get in Touch',
      infoDesc: 'Our team typically responds within 1 business day. For urgent enterprise inquiries, call us directly.',
      email: 'Email',
      phone: 'Phone',
      hq: 'HQ',
      offices: 'Our Offices',
      formTitle: 'Send us a Message',
      name: 'Full Name',
      namePlaceholder: 'the Name',
      workEmail: 'Work Email',
      emailPlaceholder: 'Enter Mail',
      company: 'Company',
      companyPlaceholder: 'Company Name',
      interestedIn: "I'm interested in",
      selectTopic: 'Select a topic...',
      message: 'Message',
      messagePlaceholder: 'Tell us about your use case or what you\'re looking for...',
      send: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Message Sent!',
      successDesc: 'Thanks for reaching out. Our team will get back to you within 1 business day.',
      sendAnother: 'Send Another',
      interests: ['Enterprise Sales', 'API Integration', 'Compliance Consultation', 'Partnership', 'Demo Request', 'Other'],
    },

    // Pricing
    pricing: {
      tag: 'Pricing',
      title1: 'Transparent Plans for',
      title2: 'Every Scale',
      desc: 'Start free and scale as you grow. No hidden fees, no surprises.',
      monthlyLabel: 'Monthly',
      yearlyLabel: 'Yearly',
      saveLabel: 'Save 20%',
      mostPopular: 'Most Popular',
      perMonth: '/mo',
      perYear: '/yr',
      startFree: 'Start Free',
      startTrial: 'Start Free Trial',
      contactSales: 'Contact Sales',
      everythingIn: 'Everything in',
      plus: 'plus',
      faqTitle: 'Frequently Asked Questions',
      faqDesc: 'Everything you need to know about KYCPro.AI pricing.',
      ctaTitle: 'Ready to Get Started?',
      ctaDesc: 'Join 500+ enterprises that trust KYCPro.AI for identity verification.',
      plans: [
        {
          name: 'Starter',
          price: { monthly: '0', yearly: '0' },
          desc: 'Perfect for developers and startups exploring identity verification.',
          features: [
            '500 verifications/month',
            'Basic ID verification',
            '10 document types supported',
            'REST API access',
            'Community support',
            'Developer dashboard',
          ],
          cta: 'Start Free',
          highlight: false,
        },
        {
          name: 'Growth',
          price: { monthly: '299', yearly: '239' },
          desc: 'For growing businesses that need reliable, high-speed verification.',
          features: [
            '10,000 verifications/month',
            'Liveness detection',
            '500+ document types',
            'AML & PEP screening',
            'Email support',
            'Compliance reporting',
            'Webhook integrations',
            '99.9% SLA uptime',
          ],
          cta: 'Start Free Trial',
          highlight: true,
        },
        {
          name: 'Enterprise',
          price: { monthly: 'Custom', yearly: 'Custom' },
          desc: 'For large organizations with complex compliance requirements.',
          features: [
            'Unlimited verifications',
            '10,000+ document types',
            'Custom risk scoring',
            'Dedicated account manager',
            '24/7 priority support',
            'Private/on-premise deployment',
            'Custom SLA agreement',
            'Onboarding & training',
          ],
          cta: 'Contact Sales',
          highlight: false,
        },
      ],
      faqs: [
        { q: 'Can I change my plan at any time?', a: 'Yes, you can upgrade or downgrade at any time. Differences are prorated automatically to your next billing cycle.' },
        { q: 'What happens if I exceed my verification limit?', a: "You'll be notified before hitting the limit. Overages are billed at a flat rate per verification — service never stops." },
        { q: 'Are there long-term contracts?', a: 'No contracts required. Both monthly and annual plans are cancel-anytime. Annual plans include a 20% discount.' },
        { q: 'Do you support invoicing in local currencies?', a: 'Yes, we support 30+ currencies and can issue invoices in your local currency to simplify accounting.' },
        { q: 'Is my data encrypted?', a: 'Absolutely. All data is encrypted in transit and at rest using AES-256. We are SOC 2 Type II and ISO 27001 certified.' },
        { q: 'Do you offer a free trial for paid plans?', a: 'Yes — the Growth plan comes with a 14-day free trial, no credit card required. Cancel any time.' },
      ],
    },

    // Privacy Policy
    privacy: {
      tag: 'Privacy Policy',
      lastUpdated: 'Last updated: April 1, 2026',
      intro: 'KYCPro.AI is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your data.',
      sections: [
        {
          title: '1. Data We Collect',
          content: 'We collect data necessary to provide identity verification services, including: personal information (name, email, phone number), government-issued identity documents, facial images for liveness checks, device data and IP address, and service usage logs.',
        },
        {
          title: '2. How We Use Your Data',
          content: 'We use your data to deliver identity verification services, comply with legal and regulatory requirements, improve the accuracy of our AI models, send service-related notifications, and detect and prevent fraud.',
        },
        {
          title: '3. Data Sharing',
          content: 'We do not sell your personal data to third parties. We may share data with trusted service providers who help us operate the platform, regulatory authorities when legally required, and clients who requested your verification.',
        },
        {
          title: '4. Data Retention',
          content: 'We retain verification data for up to 7 years in accordance with AML requirements. Facial biometric data is deleted within 24 hours of verification completion unless legally required otherwise.',
        },
        {
          title: '5. Security',
          content: 'We use AES-256 encryption for all data in transit and at rest. Our platform is SOC 2 Type II and ISO 27001 certified. We conduct regular penetration testing and independent security audits.',
        },
        {
          title: '6. Your Rights',
          content: 'You have the right to access, correct, delete, restrict processing, and port your data. You can exercise these rights by contacting us at info@CoreNexFlow.com',
        },
        {
          title: '7. Cookies',
          content: 'We use strictly necessary cookies to operate the service, and analytics cookies to improve the user experience. You can control cookie settings through your browser preferences.',
        },
        {
          title: '8. Changes to This Policy',
          content: 'We may update this policy periodically. We will notify you of any material changes via email or a prominent notice on the site. Continued use of the service after an update constitutes acceptance of the new policy.',
        },
      ],
      contactTitle: 'Contact Our Privacy Team',
      contactDesc: 'If you have questions about this policy, contact us at',
    },

    // Terms of Service
    terms: {
      tag: 'Terms of Service',
      lastUpdated: 'Last updated: April 1, 2026',
      intro: 'By using KYCPro.AI, you agree to the following terms and conditions. Please read them carefully.',
      sections: [
        {
          title: '1. Acceptance of Terms',
          content: 'By using our services, you acknowledge that you have read, understood, and agree to be bound by these terms. If you represent an organization, you warrant that you have authority to agree on its behalf.',
        },
        {
          title: '2. Service Description',
          content: 'KYCPro.AI provides identity verification and anti-money laundering services via a secure API. Services include document verification, liveness detection, sanctions list screening, and compliance reporting.',
        },
        {
          title: '3. User Accounts',
          content: 'You are responsible for maintaining the confidentiality of your account credentials. You must notify us immediately of any unauthorized use of your account. We reserve the right to suspend accounts that violate these terms.',
        },
        {
          title: '4. Acceptable Use',
          content: 'You may not use our services for illegal purposes, fraud, or violation of others\' privacy. The service must be used in accordance with applicable local laws and data protection regulations.',
        },
        {
          title: '5. Pricing and Payment',
          content: 'Prices are in USD and subject to change with prior notice. Annual subscriptions are offered at a 20% discount. All payments are non-refundable unless otherwise stated in our refund policy.',
        },
        {
          title: '6. Intellectual Property',
          content: 'All intellectual property rights in the platform and technology belong to KYCPro.AI. This agreement does not grant you any rights to our trademarks, patents, or trade secrets.',
        },
        {
          title: '7. Limitation of Liability',
          content: 'KYCPro.AI shall not be liable for indirect or incidental damages. Our total liability shall not exceed amounts paid to us in the 12 months preceding the incident.',
        },
        {
          title: '8. Termination',
          content: 'You may cancel your subscription at any time. We reserve the right to terminate or suspend service for violations of these terms with as much prior notice as reasonably possible.',
        },
       {
          title: '9. Governing Law',
          content: 'These terms are governed by the laws of the The Middle East. Any disputes are subject to the exclusive jurisdiction of the courts of Egept.',
        },  
      ],
      contactTitle: 'Questions About These Terms?',
      contactDesc: 'Contact our legal team at',
    },
  },

  ar: {
    // Navbar
    nav: {
      home: 'الرئيسية',
      useCases: 'حالات الاستخدام',
      pricing: 'الأسعار',
      about: 'من نحن',
      Features: 'المميزات',
      contact: 'تواصل معنا',
      getStarted: 'ابدأ الآن',
    },

    // Footer
    footer: {
      tagline: 'التحقق من الهوية بالذكاء الاصطناعي وكشف الاحتيال للمؤسسات الحديثة.',
      product: 'المنتج',
      company: 'الشركة',
      legal: 'قانوني',
      features: 'المميزات',
      Features: 'المميزات',
      pricing: 'الأسعار',
      api: 'توثيق API',
      about: 'من نحن',
      careers: 'وظائف',
      blog: 'المدونة',
      press: 'الصحافة',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة',
      gdpr: 'GDPR',
      compliance: 'الامتثال',
      rights: 'جميع الحقوق محفوظة.',
      built: 'مبني بالذكاء الاصطناعي. محمي بالتصميم.',
    },

    // Home
    home: {
      badgeText: 'موثوق به من قِبَل أكثر من 5+ مؤسسة حول العالم',
      heroTitle1: 'التحقق من الهوية',
      heroTitle2: 'مدعوم بـ',
      heroTitle3: 'دقة الذكاء الاصطناعي',
      heroSubtitle: 'تقدم KYCPro.AI امتثالاً على مستوى المؤسسات لـ KYC وAML مع التحقق الفوري وكشف الاحتيال والتكامل السلس — كل ذلك في أقل من ثانيتين.',
      startTrial: 'ابدأ التجربة المجانية',
      exploreUseCases: 'استكشف حالات الاستخدام',
      Features: 'المميزات',
      verificationActive: 'التحقق نشط',
      idVerified: '✓ تم التحقق من الهوية',
      livenessPass: '✓ اجتياز فحص الحيوية',
      amlClear: '✓ AML نظيف',
      stats: [
        { value: '99.8%', label: 'معدل الدقة' },
        { value: '<2ث', label: 'سرعة التحقق' },
        { value: '+190', label: 'دولة مغطاة' },
        { value: '+10م', label: 'عمليات تحقق' },
      ],
      trustedLabel: 'موثوق به من كبرى المؤسسات المالية',
      capabilitiesTag: 'القدرات',
      capabilitiesTitle1: 'كل ما تحتاجه لـ',
      capabilitiesTitle2: 'امتثال KYC الحديث',
      capabilitiesDesc: 'منصة متكاملة للتحقق من الهوية مبنية للسرعة والدقة والنطاق العالمي.',
      features: [
        { title: 'التحقق من الهوية فوري', desc: 'التحقق الفوري من الهويات الحكومية وجوازات السفر ورخص القيادة باستخدام تحليل المستندات بالذكاء الاصطناعي.' },
        { title: 'كشف الحيوية', desc: 'منع هجمات الانتحال باستخدام تقنية كشف الحيوية ثلاثية الأبعاد التي تميز المستخدمين الحقيقيين عن الصور أو التزييف العميق.' },
        { title: 'تغطية عالمية', desc: 'دعم أكثر من 10,000 نوع مستند في أكثر من 190 دولة مع OCR متعدد اللغات واستخراج البيانات.' },
        { title: 'قرارات فورية', desc: 'قرارات تحقق في أقل من ثانيتين مدعومة بنماذج ذكاء اصطناعي متوازية تعمل على البنية التحتية الحافة.' },
        { title: 'تسجيل المخاطر', desc: 'تسجيل مخاطر ديناميكي مع إشارات ذكاء اصطناعي قابلة للتفسير لمساعدة فريق الامتثال لديك في اتخاذ قرارات مستنيرة.' },
        { title: 'فحص AML وPEP', desc: 'فحص المستخدمين مقابل قوائم العقوبات العالمية وقواعد بيانات PEP والإعلام السلبي في الوقت الفعلي.' },
      ],
      securityTag: 'الأمان والامتثال',
      securityTitle1: 'مبني للأكثر',
      securityTitle2: 'الصناعات المنظمة',
      securityDesc: 'تلبي منصتنا أشد المتطلبات التنظيمية صرامة عبر الخدمات المالية والرعاية الصحية والتقنية المالية — حتى تتمكن من التركيز على النمو وليس على عبء الامتثال.',
      benefits: [
        'متوافق مع GDPR و CCPA بالتصميم',
        'لا يُخزَّن أي بيانات بدون موافقة',
        'خط أنابيب مشفر من طرف إلى طرف',
        'دعم امتثال مخصص',
      ],
      talkCompliance: 'تحدث مع فريق الامتثال',
      ctaTitle: 'هل أنت مستعد للتحقق بذكاء أكبر؟',
      ctaDesc: 'كن من الخمسه الاوائل المنظمين في استخدام KYCPro.AI للتحقق من الهويات في ثوانٍ، والحد من الاحتيال، والامتثال للقوانين و للحصول على ميزات فريده.',
      viewUseCases: 'عرض حالات الاستخدام',

    },

    // Use Cases
    useCases: {
      tag: 'حالات الاستخدام',
      title1: 'التحقق لـ',
      title2: 'كل صناعة',
      desc: 'من التقنية المالية إلى الرعاية الصحية، تدعم KYCPro.AI التحقق من الهوية الممتثل عبر أكثر الصناعات تنظيماً في العالم.',
      getStarted: 'ابدأ الآن',
      ctaTitle: 'لا ترى صناعتك؟',
      ctaDesc: 'منصتنا مرنة ويمكن تخصيصها لأي صناعة منظمة. تحدث مع فريقنا لبناء تدفق تحقق مخصص.',
      contactSales: 'تواصل مع المبيعات',
      cases: [
        {
          category: 'الخدمات المالية',
          title: 'إدخال العملاء بدون احتكاك',
          desc: 'تستخدم البنوك وشركات التقنية المالية KYCPro.AI للتحقق من العملاء الجدد في ثوانٍ — مما يقلل معدلات التخلي بنسبة تصل إلى 70% مع البقاء ممتثلاً تماماً لأنظمة AML وKYC.',
          benefits: ['التحقق الآلي من المستندات', 'فحص PEP والعقوبات', 'تدفقات إدخال قائمة على المخاطر', 'مسار تدقيق كامل'],
        },
      /*   {
          category: 'التجارة الإلكترونية والأسواق',
          title: 'القضاء على البائعين والمشترين المحتالين',
          desc: 'تستخدم الأسواق منصتنا للتحقق من هويات التجار ومنع الاستيلاء على الحسابات وبناء الثقة بين المشترين والبائعين على نطاق واسع.',
          benefits: ['التحقق من هوية البائع', 'منع احتيال رد المبالغ', 'حماية الاستيلاء على الحساب', 'إشارات ثقة المشتري'],
        },
        {
          category: 'الرعاية الصحية',
          title: 'التحقق من هوية المريض بأمان',
          desc: 'تستخدم منصات الرعاية الصحية KYCPro.AI لإدخال المرضى والتحقق من أوراق اعتماد الممارسين وضمان التحقق من الهوية المتوافق مع HIPAA عبر سير عمل التطبيب عن بعد.',
          benefits: ['تدفقات متوافقة مع HIPAA', 'فحوصات أوراق اعتماد الممارسين', 'التحقق من التأمين', 'عدم تخزين PHI'],
        },
        {
          category: 'الألعاب والألعاب الإلكترونية',
          title: 'التحقق من العمر وحماية اللاعبين',
          desc: 'يستخدم مشغلو الألعاب منصتنا للتحقق الفوري من العمر والامتثال للمقامرة المسؤولة ومنع الاحتيال عبر الولايات القضائية.',
          benefits: ['التحقق الفوري من العمر', 'فحوصات الامتثال الجغرافي', 'إشارات المقامرة الإشكالية', 'كشف أنماط الاحتيال'],
        }, */
        {
          category: 'العقارات',
          title: 'KYC للمعاملات العقارية',
          desc: 'تتحقق منصات ووكالات العقارات من المشترين والبائعين والوكلاء رقمياً — مما يلغي KYC الورقي ويضمن الامتثال لمكافحة غسيل الأموال.',
          benefits: ['التوقيع الرقمي للمستندات', 'التحقق من UBO', 'فحص AML', 'مراقبة المعاملات'],
        },
        {
          category: 'السفر والضيافة',
          title: 'التحقق من الضيوف بسلاسة',
          desc: 'تستخدم شركات السفر والفنادق KYCPro.AI للتحقق المسبق من الضيوف رقمياً — مما يقلل وقت تسجيل الوصول ويمنع رد المبالغ ويؤمن الحجوزات.',
          benefits: ['مسح جوازات السفر وNFC', 'منع احتيال الحجز', 'تدفقات تسجيل الوصول الرقمي', 'دعم الهوية الدولية'],
        },
      ],
    },

    // About
    about: {
      tag: 'من نحن',
      title1: 'مهمتنا جعل',
      title2: 'التحقق من الهوية موثوقاً',
      desc: 'تأسست KYCPro.AI للقضاء على الاحتكاك وعدم الدقة ومخاطر الخصوصية في عمليات KYC التقليدية — واستبدالها بدقة الذكاء الاصطناعي.',
      storyTag: 'قصتنا',
      storyTitle1: 'من الإحباط',
      storyTitle2: 'إلى الابتكار',
      storyP1: 'أمضى مؤسسونا سنوات في بناء بنية تحتية للامتثال في كبرى البنوك في الشرق الاوسط — وكانوا يشعرون بالإحباط من مشاهدة العملاء يتخلون عن تدفقات الإدخال بسبب عمليات التحقق البطيئة وغير الموثوقة.',
      storyP2: 'في عام 2025، تركوا وظائفهم لبناء المنصة التي كانوا يتمنون دائماً وجودها: منصة يمكنها التحقق من أي شخص، في أي مكان، في ثوانٍ — دون التضحية بالأمان أو الامتثال.',
      storyP3: 'اليوم، تعالج KYCPro.AI ملايين عمليات التحقق كل شهر لبعض أكثر الشركات تنظيماً في العالم. نحن فقط بدأنا.',
      milestones: [
        { year: '2025', event: 'تأسست في الشرق الاوسط بمهمة جعل التحقق من الهوية سلساً' },
        { year: '2025', event: 'إطلاق v1 مع 50 عميلاً من المؤسسات في 3 دول' },
        { year: '2026', event: 'وصول 10 ملايين عملية تحقق؛ حصل على شهادات SOC 2 Type II وISO 27001' },
        { year: '2026', event: 'إطلاق نماذج AI من الجيل التالي بدقة 99.8٪ عبر أكثر من 10,000 نوع مستند' },
      ],
      valuesTag: 'قيمنا',
      valuesTitle1: 'ما يدفع',
      valuesTitle2: 'كل ما نفعله',
      values: [
        { title: 'الدقة أولاً', desc: 'كل قرار نتخذه مبني على الدقة. نحن نهتم بالإيجابيات والسلبيات الكاذبة لأن أخطاء الامتثال لها عواقب حقيقية.' },
        { title: 'الخصوصية بالتصميم', desc: 'لا نخزن أبداً البيانات التي لا نحتاجها. الخصوصية ليست مجرد خانة اختيار بالنسبة لنا — بل هي مدمجة في كل مكون من مكونات منصتنا.' },
        { title: 'السرعة مهمة', desc: 'التحقق البطيء يكلفك التحويلات. بنينا بنيتنا التحتية لتقديم القرارات في أقل من ثانيتين، عالمياً، دون التضحية بالدقة.' },
        { title: 'هوس العملاء', desc: 'نتكامل مع فرق الامتثال لدى عملائنا، ونفهم بيئاتهم التنظيمية المحددة، ونبني حلولاً تناسب واقعهم.' },
      ],
      teamTag: 'القيادة',
      teamTitle1: 'الفريق وراء',
      teamTitle2: 'KYCPro.AI',
      team: [
        { name: ' ', role: 'الرئيس التنفيذي والمؤسس المشارك' },
        { name: ' ', role: 'المدير التقني والمؤسس المشارك' },
        { name: ' ', role: 'مسؤول الامتثال الرئيسي' },
      ],
      ctaTitle: 'انضم إلينا في المهمة',
      ctaDesc: 'سواء كنت عميلاً أو شريكاً أو زميلاً مستقبلياً — نحب التواصل معك.',
      getInTouch: 'تواصل معنا',
      openRoles: 'عرض الوظائف المتاحة',
    },

    // Contact
    contact: {
      tag: 'تواصل معنا',
      title1: 'لنتحدث عن',
      title2: 'التحقق',
      desc: 'سواء كنت تحتاج إلى عرض توضيحي أو لديك أسئلة حول الامتثال أو أنت مستعد للتكامل — فريقنا هنا.',
      infoTitle: 'تواصل معنا',
      infoDesc: 'يستجيب فريقنا عادةً في غضون يوم عمل واحد. للاستفسارات العاجلة للمؤسسات، اتصل بنا مباشرة.',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      hq: 'المقر الرئيسي',
      offices: 'مكاتبنا',
      formTitle: 'أرسل لنا رسالة',
      name: 'الاسم الكامل',
      namePlaceholder: 'الاسم',
      workEmail: 'البريد الإلكتروني للعمل',
      emailPlaceholder: 'ادخل الايميل',
      company: 'الشركة',
      companyPlaceholder: 'اسم الشركة ',
      interestedIn: 'أنا مهتم بـ',
      selectTopic: 'اختر موضوعاً...',
      message: 'الرسالة',
      messagePlaceholder: 'أخبرنا عن حالة استخدامك أو ما تبحث عنه...',
      send: 'إرسال الرسالة',
      sending: 'جاري الإرسال...',
      successTitle: 'تم إرسال الرسالة!',
      successDesc: 'شكراً على تواصلك. سيرد فريقنا عليك خلال يوم عمل واحد.',
      sendAnother: 'إرسال رسالة أخرى',
      interests: ['مبيعات المؤسسات', 'تكامل API', 'استشارة الامتثال', 'الشراكة', 'طلب عرض توضيحي', 'أخرى'],
    },

    // Pricing
    pricing: {
      tag: 'الأسعار',
      title1: 'خطط شفافة',
      title2: 'لكل حجم',
      desc: 'ابدأ مجاناً وتوسع مع نموك. لا رسوم خفية، لا مفاجآت.',
      monthlyLabel: 'شهري',
      yearlyLabel: 'سنوي',
      saveLabel: 'وفر 20%',
      mostPopular: 'الأكثر شعبية',
      perMonth: '/شهر',
      perYear: '/سنة',
      startFree: 'ابدأ مجاناً',
      startTrial: 'ابدأ التجربة',
      contactSales: 'تواصل مع المبيعات',
      everythingIn: 'كل شيء في',
      plus: 'بالإضافة إلى',
      faqTitle: 'الأسئلة الشائعة',
      faqDesc: 'كل ما تحتاج معرفته حول أسعار KYCPro.AI.',
      ctaTitle: 'هل أنت مستعد للبدء؟',
      ctaDesc: 'انضم إلى أكثر من 500 مؤسسة تثق بـ KYCPro.AI للتحقق من الهوية.',
      plans: [
        {
          name: 'مجاني',
          price: { monthly: '0', yearly: '0' },
          desc: 'مثالي للمطورين والشركات الناشئة التي تريد الاستكشاف.',
          features: [
            '500 تحقق شهرياً',
            'التحقق من الهوية الأساسية',
            'دعم 10 أنواع مستندات',
            'واجهة برمجة التطبيقات REST',
            'دعم المجتمع',
            'لوحة تحكم المطور',
          ],
          cta: 'ابدأ مجاناً',
          highlight: false,
        },
        {
          name: 'نمو',
          price: { monthly: '299', yearly: '239' },
          desc: 'للشركات النامية التي تحتاج تحققاً موثوقاً وسريعاً.',
          features: [
            '10,000 تحقق شهرياً',
            'كشف الحيوية',
            'دعم 500+ نوع مستند',
            'فحص AML وPEP',
            'دعم عبر البريد الإلكتروني',
            'تقارير الامتثال',
            'تكامل Webhook',
            'SLA بنسبة 99.9٪',
          ],
          cta: 'ابدأ التجربة',
          highlight: true,
        },
        {
          name: 'مؤسسة',
          price: { monthly: 'مخصص', yearly: 'مخصص' },
          desc: 'للمؤسسات الكبيرة ذات المتطلبات المعقدة.',
          features: [
            'تحققات غير محدودة',
            'دعم 10,000+ نوع مستند',
            'تسجيل مخاطر مخصص',
            'مدير حساب مخصص',
            'دعم على مدار الساعة',
            'نشر خاص/على الخادم',
            'اتفاقية SLA مخصصة',
            'التدريب والتأهيل',
          ],
          cta: 'تواصل مع المبيعات',
          highlight: false,
        },
      ],
      faqs: [
        { q: 'هل يمكنني تغيير خطتي في أي وقت?', a: 'نعم، يمكنك الترقية أو الرجوع في أي وقت. سيتم احتساب الفرق تلقائياً.' },
        { q: 'ماذا يحدث إذا تجاوزت حد التحققات?', a: 'سيتم إشعارك وستستمر الخدمة. يتم احتساب التحققات الإضافية بسعر ثابت.' },
        { q: 'هل هناك عقد طويل الأجل?', a: 'لا. خططنا الشهرية والسنوية بدون عقود. يمكنك الإلغاء في أي وقت.' },
        { q: 'هل تقدمون فاتورة بالعملة المحلية?', a: 'نعم، ندعم أكثر من 30 عملة مختلفة ونوفر فواتير متوافقة مع متطلباتك.' },
        { q: 'هل البيانات مشفرة?', a: 'نعم، جميع البيانات مشفرة أثناء النقل وفي حالة السكون باستخدام AES-256.' },
        { q: 'هل تقدمون تجربة مجانية للخطط المدفوعة?', a: 'نعم، نقدم 14 يوماً تجربة مجانية لخطة النمو بدون الحاجة لبطاقة ائتمان.' },
      ],
    },

    // Privacy Policy
    privacy: {
      tag: 'سياسة الخصوصية',
      lastUpdated: 'آخر تحديث: 1 أبريل 2026',
      intro: 'تلتزم KYCPro.AI بحماية خصوصيتك. توضح هذه السياسة كيفية جمع بياناتك واستخدامها وحمايتها.',
      sections: [
        {
          title: '1. البيانات التي نجمعها',
          content: 'نجمع البيانات اللازمة لتقديم خدمات التحقق من الهوية، بما في ذلك: المعلومات الشخصية (الاسم، البريد الإلكتروني، رقم الهاتف)، وثائق الهوية الحكومية، صور الوجه لفحص الحيوية، بيانات الجهاز وعنوان IP، وسجلات استخدام الخدمة.',
        },
        {
          title: '2. كيفية استخدام بياناتك',
          content: 'نستخدم بياناتك لتقديم خدمات التحقق من الهوية، والامتثال للمتطلبات القانونية والتنظيمية، وتحسين دقة نماذجنا الذكية، وإرسال إشعارات تتعلق بالخدمة، وكشف الاحتيال ومنعه.',
        },
        {
          title: '3. مشاركة البيانات',
          content: 'لا نبيع بياناتك الشخصية لأطراف ثالثة. قد نشارك البيانات مع مزودي الخدمة الموثوقين الذين يساعدوننا في تشغيل المنصة، والجهات التنظيمية عند الاقتضاء القانوني، والعملاء الذين طلبوا التحقق منك.',
        },
        {
          title: '4. الاحتفاظ بالبيانات',
          content: 'نحتفظ ببيانات التحقق لمدة لا تزيد عن 7 سنوات وفقاً لمتطلبات مكافحة غسيل الأموال. بيانات بصمة الوجه تُحذف خلال 24 ساعة من إتمام التحقق ما لم يُطلب خلاف ذلك قانونياً.',
        },
        {
          title: '5. الأمان',
          content: 'نستخدم تشفير AES-256 لجميع البيانات أثناء النقل وفي حالة السكون. منصتنا معتمدة بـ SOC 2 Type II وISO 27001. نجري اختبارات اختراق دورية وتدقيقاً أمنياً مستقلاً.',
        },
        {
          title: '6. حقوقك',
          content: 'يحق لك الوصول إلى بياناتك، تصحيحها، حذفها، تقييد معالجتها، ونقلها. يمكنك ممارسة هذه الحقوق عبر التواصل معنا على info@CoreNexFlow.com',
        },
        {
          title: '7. ملفات تعريف الارتباط',
          content: 'نستخدم ملفات تعريف الارتباط الضرورية لتشغيل الخدمة، وملفات التحليلات لتحسين تجربة المستخدم. يمكنك التحكم في إعدادات ملفات تعريف الارتباط من متصفحك.',
        },
        {
          title: '8. التغييرات على هذه السياسة',
          content: 'قد نحدّث هذه السياسة دورياً. سنخطرك بأي تغييرات جوهرية عبر البريد الإلكتروني أو إشعار بارز على الموقع. استمرارك في استخدام الخدمة بعد التحديث يعني موافقتك على السياسة الجديدة.',
        },
      ],
      contactTitle: 'تواصل مع فريق الخصوصية',
      contactDesc: 'إذا كانت لديك أسئلة حول هذه السياسة، تواصل معنا على',
    },

    // Terms of Service
    terms: {
      tag: 'شروط الخدمة',
      lastUpdated: 'آخر تحديث: 1 أبريل 2026',
      intro: 'باستخدامك لمنصة KYCPro.AI، فإنك توافق على الشروط والأحكام التالية. يرجى قراءتها بعناية.',
      sections: [
        {
          title: '1. قبول الشروط',
          content: 'باستخدامك لخدماتنا، فإنك تقر بأنك قرأت وفهمت ووافقت على الالتزام بهذه الشروط. إذا كنت تمثل مؤسسة، فإنك تضمن أن لديك الصلاحية للموافقة نيابةً عنها.',
        },
        {
          title: '2. وصف الخدمة',
          content: 'تقدم KYCPro.AI خدمات التحقق من الهوية ومكافحة غسيل الأموال عبر واجهة برمجة تطبيقات آمنة. تشمل الخدمات: التحقق من الوثائق، فحص الحيوية، فحص القوائم المقيدة، وتقارير الامتثال.',
        },
        {
          title: '3. حسابات المستخدمين',
          content: 'أنت مسؤول عن الحفاظ على سرية بيانات اعتماد حسابك. يجب إخطارنا فوراً بأي استخدام غير مصرح به لحسابك. نحتفظ بحق تعليق الحسابات التي تنتهك هذه الشروط.',
        },
        {
          title: '4. الاستخدام المقبول',
          content: 'يُحظر استخدام خدماتنا لأغراض غير قانونية، أو الاحتيال، أو انتهاك خصوصية الآخرين. يجب استخدام الخدمة وفق التشريعات المحلية وقوانين حماية البيانات المعمول بها.',
        },
        {
          title: '5. الأسعار والدفع',
          content: 'الأسعار المعروضة بالدولار الأمريكي وتخضع للتغيير مع إشعار مسبق. تُقدم الاشتراكات السنوية بخصم 20٪. جميع المدفوعات غير قابلة للاسترداد ما لم ينص على خلاف ذلك في سياسة الاسترداد.',
        },
        {
          title: '6. الملكية الفكرية',
          content: 'جميع حقوق الملكية الفكرية المتعلقة بالمنصة والتكنولوجيا تعود لـ KYCPro.AI. لا يمنحك هذا الاتفاق أي حقوق في علامتنا التجارية أو براءات الاختراع أو الأسرار التجارية.',
        },
        {
          title: '7. حدود المسؤولية',
          content: 'لن تكون KYCPro.AI مسؤولة عن الأضرار غير المباشرة أو العرضية. مسؤوليتنا الإجمالية لا تتجاوز المبالغ المدفوعة لنا خلال الـ 12 شهراً السابقة للحادثة.',
        },
        {
          title: '8. إنهاء الخدمة',
          content: 'يمكنك إلغاء اشتراكك في أي وقت. نحتفظ بحق إنهاء أو تعليق الخدمة في حالة انتهاك هذه الشروط مع إشعار مسبق قدر المستطاع.',
        },
        {
          title: '9. القانون الحاكم',
          content: 'تخضع هذه الشروط لقوانين في الشرق الاوسط. أي نزاعات تخضع للاختصاص الحصري لمحاكم  القاهره.',
        },
      ],
      contactTitle: 'أسئلة حول الشروط؟',
      contactDesc: 'تواصل مع فريقنا القانوني على',
    },
  },
};

export default translations;
